<template>
  <div class="manual-text">
    <div>
      <h1 class="text-center mt-2 mb-10">Project Comparison</h1>
      <p>
        In the <b>projects page</b>, users can use the <b>checkbox in the rightmost column</b> of each row, to select multiple
        projects for comparison. This feature allows for a structured evaluation <b>up to four projects</b>, which
        provides insights that are more or less similar to those of the SII & SPI Analysis for the KPIs and the PPI Analysis for the PSIs.
        It is required to select at least two projects and four at most. Once the desired amount of projects has been selected,
        the "Compare" button becomes available to click, which leads to the Comparison Page.
      </p>

      <div class="image-container">
        <img src="@/images/manual/projects-page-comparison-column.png" alt="project comparison column">
        <div class="img-caption">Figure 1: Selecting projects to compare. </div>
      </div>

      <br>

      <p>
        For a project to be included in the comparison, it must meet certain criteria. A fundamental requirement is that
        <b>every project must have at least one KPI and one PSI.</b> If a project lacks these essential elements, the comparison
        cannot proceed. In such cases, users will be notified about which projects are missing the required data.
      </p>

      <div class="image-container">
        <img src="@/images/manual/project-comparison-empty-error.png" alt="project comparison empty error">
        <div class="img-caption">Figure 2: Alert with an "empty" project.</div>
      </div>

      <p>
        All other scenarios of faulty analyses are induced from the KPIs/PSIs themselves. Such cases will not be as
        self-explanatory as the above, but there will be an overview of what caused the analysis to run into problems.
        For instance, there might be some KPIs that have wrong margins, or the sum of the weights in some sectors not
        being equal to 1.
      </p>

      <div class="image-container">
        <img src="@/images/manual/project-comparison-sum-of-weights-error.png" alt="project comparison sum of weights">
        <div class="img-caption">Figure 3: Alert with a KPI "sum of weights" error.</div>
      </div>

      <p>
        In any other case, all analyses that run smoothly without errors, will be redirected to the following screen.
        To see a more in-depth explanation to what the user will expect to see in this page click the sub-sectors of
        the analyses. As mentioned before, almost all graphs are the same as the analyses throughout the entire comparison
        page.
      </p>

      <div class="image-container">
        <v-row>
          <v-col>
            <img src="@/images/manual/comparison-kpis-first-graph.png" alt="first kpi graph">
          </v-col>
          <v-col>
            <img src="@/images/manual/comparison-psis-graph.png" alt="first psi graph">
          </v-col>
        </v-row>
        <div class="img-caption">Figure 4: The analysis run with no errors (3 projects compared). </div>
      </div>

    </div>
  </div>
</template>

<script setup>

</script>

<style scoped>

</style>
